export default {
  // Common / Navigation
  site_name: "CSSBuyBR",
  nav_spreadsheet: "CSSBuy Spreadsheet",
  nav_categories: "Categorias",
  nav_guides: "Guias",
  nav_reviews: "Reviews",
  nav_shipping: "Envio",
  nav_safety: "Segurança",
  nav_home: "Início",
  nav_shopping_guide: "Guia de Compras",
  nav_about: "Sobre",
  language: "Idioma",
  lang_pt: "Português",
  lang_de: "Deutsch",
  lang_en: "English",
  open_spreadsheet: "Abrir Spreadsheet",
  main_cta: "CSSBuy Spreadsheet",
  buy_now: "Buy It Now",
  search_placeholder: "Pesquisar no CSSBuy Spreadsheet...",
  updated: "Atualizado",
  independent_notice: "Recurso Independente",
  disclaimer_short: "Não é o site oficial da CSSBuy",
  read_more: "Ler mais",
  explore: "Explorar",
  learn_more: "Saiba mais",
  back_to_home: "Voltar para Início",
  related_articles: "Artigos Relacionados",
  table_of_contents: "Conteúdo",
  author: "Autor",
  published: "Publicado",
  last_updated: "Última atualização",
  quick_answer: "Resposta Rápida",
  conclusion: "Conclusão",
  faq: "Perguntas Frequentes",
  pros: "Prós",
  cons: "Contras",
  step_by_step: "Passo a Passo",
  what_youll_learn: "O que você vai aprender",
  trust_badge: "Informação independente • Guias práticos • Dados organizados",
  safety_cta: "Guia de Segurança CSSBuy",
  footer_about: "Sobre",
  footer_safety: "Segurança",
  footer_disclaimer: "Disclaimer",
  footer_privacy: "Privacidade",
  footer_terms: "Termos",
  footer_contact: "Contato",
  footer_resources: "Recursos",
  footer_copyright: "© 2026 CSSBuyBR.info. Recurso independente — não é o site oficial da CSSBuy.",
  disclaimer_full: "CSSBuyBR.info é um recurso informativo independente e não é o site oficial da CSSBuy. Não processamos pagamentos, não vendemos produtos e não temos afiliação com a CSSBuy. Sempre verifique informações importantes de conta, pagamento, envio e políticas através dos canais oficiais antes de tomar qualquer ação.",
  
  // Hero
  hero_eyebrow: "CSSBUY • SPREADSHEET • GUIAS DE COMPRA",
  hero_title: "CSSBuy Spreadsheet: Encontre Produtos e Guias para Comprar com Mais Confiança",
  hero_subtitle: "Explore um CSSBuy Spreadsheet organizado por categorias e encontre guias práticos sobre produtos, QC, armazenamento, custos de envio, cupons e o processo de compra.",
  hero_cta_primary: "Explorar CSSBuy Spreadsheet",
  hero_cta_secondary: "Ver Guias CSSBuy",
  hero_trust: "Recursos independentes • Guias práticos • Informações organizadas",
  
  // Categories Section
  categories_title: "Categorias de Produtos",
  categories_subtitle: "Navegue por categorias populares e encontre o que você procura no CSSBuy Spreadsheet.",
  category_shoes: "Tênis",
  category_hoodies: "Moletons",
  category_tshirts: "Camisetas",
  category_jackets: "Jaquetas",
  category_pants: "Calças/Shorts",
  category_headwear: "Bonés",
  category_sets: "Conjuntos",
  category_underwear: "Roupa Íntima",
  category_jersey: "Jerseys",
  category_accessories: "Acessórios",
  category_bags: "Bolsas",
  category_belts: "Cintos",
  category_perfumes: "Perfumes",
  category_other: "Outros",
  
  // Spreadsheet Section
  spreadsheet_title: "CSSBuy Spreadsheet em um só lugar",
  spreadsheet_desc: "Encontrar produtos pode ser complicado quando as informações estão espalhadas por diferentes fontes. Nosso objetivo é organizar categorias, recursos e guias relacionados ao CSSBuy Spreadsheet para tornar sua pesquisa mais simples e ajudar você a tomar decisões mais informadas.",
  spreadsheet_card_products: "Produtos",
  spreadsheet_card_products_desc: "Explore produtos e categorias organizadas.",
  spreadsheet_card_guides: "Guias",
  spreadsheet_card_guides_desc: "Aprenda como pesquisar, comparar e verificar informações.",
  spreadsheet_card_shipping: "Envio",
  spreadsheet_card_shipping_desc: "Entenda custos, peso, opções e fatores que influenciam o envio.",
  spreadsheet_card_safety: "Segurança",
  spreadsheet_card_safety_desc: "Aprenda a identificar links, ofertas e informações potencialmente suspeitas.",
  spreadsheet_cta: "Explorar categorias",
  
  // How It Works
  how_title: "Como usar um CSSBuy Spreadsheet",
  how_step1_title: "Encontre um produto",
  how_step1_desc: "Pesquise por categoria e identifique opções relevantes.",
  how_step2_title: "Verifique as informações",
  how_step2_desc: "Confira links, imagens, medidas e detalhes disponíveis.",
  how_step3_title: "Compare opções",
  how_step3_desc: "Consulte QC e compare diferentes alternativas.",
  how_step4_title: "Tome sua decisão",
  how_step4_desc: "Confirme preços, políticas e informações atuais antes de comprar.",
  how_cta: "Abrir CSSBuy Spreadsheet",
  
  // Popular Topics
  topics_title: "Tudo o que você precisa saber sobre CSSBuy",
  topic_review_title: "CSSBuy Review",
  topic_review_desc: "Veja como funciona, principais características, limitações e fatores importantes.",
  topic_shipping_title: "CSSBuy Shipping Cost",
  topic_shipping_desc: "Entenda os principais fatores que influenciam o custo final de envio.",
  topic_coupon_title: "CSSBuy Coupon",
  topic_coupon_desc: "Saiba como encontrar e verificar ofertas atuais.",
  topic_discount_title: "CSSBuy Discount Code",
  topic_discount_desc: "Aprenda como verificar códigos e condições antes de utilizá-los.",
  topic_warehouse_title: "CSSBuy Warehouse",
  topic_warehouse_desc: "Entenda armazenamento, QC e preparação de pedidos.",
  topic_legit_title: "CSSBuy Legit",
  topic_legit_desc: "Conheça os principais pontos que devem ser analisados antes de utilizar qualquer serviço.",
  
  // Trust Section
  trust_title: "Informação antes de comprar",
  trust_desc: "O CSSBuyBR.info é um recurso independente. Não somos o site oficial da CSSBuy, não processamos pagamentos e não vendemos produtos. Nosso objetivo é organizar informações úteis para pesquisa, comparação e educação do consumidor.",
  
  // Final CTA
  final_cta_title: "Pronto para explorar o CSSBuy Spreadsheet?",
  final_cta_desc: "Comece por uma categoria, consulte nossos guias e confirme sempre as informações atuais antes de realizar uma compra.",
  final_cta_primary: "Explorar CSSBuy Spreadsheet",
  final_cta_secondary: "Visitar Main Website",
  
  // Article Page
  article_intro: "Introdução",
  article_what_is: "O que é CSSBuy Spreadsheet",
  article_how_to_use: "Como usar o CSSBuy Spreadsheet",
  article_categories: "Categorias principais",
  article_shipping: "Envio e custos",
  article_qc: "QC e verificação",
  article_tips: "Dicas práticas",
  article_comparison: "Comparação com alternativas",
  article_safety: "Segurança e cuidados",
  article_conclusion: "Conclusão",
  
  // Meta
  meta_home_title: "CSSBuy Spreadsheet: Encontre Produtos, Guias e Recursos de Compra",
  meta_home_desc: "Explore um CSSBuy Spreadsheet organizado com produtos, categorias, guias, QC, envio, cupons e informações de segurança para facilitar sua pesquisa.",
  meta_article_title: "CSSBuy Spreadsheet: Guia Completo para Encontrar e Comparar Produtos",
  meta_article_desc: "Guia completo do CSSBuy Spreadsheet. Aprenda a pesquisar, comparar categorias, verificar QC e entender custos de envio para comprar com mais confiança.",
  
  // Category URLs
  cat_url_shoes: "https://kaspreadsheet.com/category-911-Shoes.html",
  cat_url_hoodies: "https://kaspreadsheet.com/search-912/name/Shoes.html",
  cat_url_tshirts: "https://kaspreadsheet.com/search-913/name/Shoes.html",
  cat_url_jackets: "https://kaspreadsheet.com/search-914/name/Shoes.html",
  cat_url_pants: "https://kaspreadsheet.com/search-915/name/Shoes.html",
  cat_url_headwear: "https://kaspreadsheet.com/search-916/name/Shoes.html",
  cat_url_sets: "https://kaspreadsheet.com/search-917/name/Shoes.html",
  cat_url_underwear: "https://kaspreadsheet.com/search-918/name/Shoes.html",
  cat_url_jersey: "https://kaspreadsheet.com/search-919/name/Shoes.html",
  cat_url_accessories: "https://kaspreadsheet.com/search-920/name/Shoes.html",
  cat_url_bags: "https://kaspreadsheet.com/search-921/name/Shoes.html",
  cat_url_belts: "https://kaspreadsheet.com/search-922/name/Shoes.html",
  cat_url_perfumes: "https://kaspreadsheet.com/search-923/name/Shoes.html",
  cat_url_other: "https://kaspreadsheet.com/search-924/name/Shoes.html",
  main_site_url: "https://kaspreadsheet.com",
};